import type { PostMeta } from "../posts";

export const meta: PostMeta = {
  slug: "best-study-spots-north-campus",
  title: "Quiet Corners: The 10 Best Study Spots & Libraries in DU North Campus",
  description:
    "From Arts Faculty Library and Ratan Tata Library to quiet college reading rooms and student-friendly cafes, a complete map of study spots in DU North Campus.",
  pubDate: "2026-06-15",
  updatedDate: "2026-07-28",
  authorSlug: "uday-kumar",
  category: "college-life",
  tags: ["north-campus", "study-spots", "delhi-university", "libraries", "duls"],
  readMinutes: 8,
  heroEyebrow: "Campus · Guide",
};

export function Body() {
  return (
    <>
      <p>
        Finding quiet, distraction-free study space in North Campus during exam season requires knowing campus geography beyond individual college reading rooms. Central library access rules and timings are maintained on the official{" "}
        <a href="https://ccls.du.ac.in/" target="_blank" rel="noopener noreferrer">
          Delhi University Library System (DULS) Portal
        </a>
        .
      </p>

      <h2>Top Library &amp; Reading Room Locations</h2>
      <ul className="space-y-2 my-4">
        <li>
          <strong>1. Central Library &amp; Arts Faculty Main Reading Room:</strong> Located near University Road main gate. Access guidelines and membership details at{" "}
          <a href="https://www.du.ac.in/" target="_blank" rel="noopener noreferrer">
            du.ac.in
          </a>
          . High seating capacity, quiet environment, open till late during sessional exams.
        </li>
        <li>
          <strong>2. Ratan Tata Library (RTL), Delhi School of Economics:</strong> Premier economics research collection. Access restricted to postgraduate students and registered DSE/DU economics undergraduates.
        </li>
        <li>
          <strong>3. Law Faculty Reading Room:</strong> Quiet air-conditioned seating with individual study cubicles.
        </li>
      </ul>

      <h2>Related College Life Reading</h2>
      <p>
        Optimize your study routine by pairing your spot selection with our guides on{" "}
        <a href="/blog/study-timetable-you-actually-follow" className="font-semibold underline text-grade">
          Energy-Aware Study Timetables
        </a>{" "}
        and{" "}
        <a href="/blog/du-grading-attendance-explained" className="font-semibold underline text-grade">
          DU Grading and Attendance Rules
        </a>
        .
      </p>
    </>
  );
}


